module.exports = __webpack_public_path__ + "img/instruction.18091b15.jpeg";